'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styleSheet = exports.Loader = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _jssThemeReactor = require('jss-theme-reactor');

var _PropTypes = require('../utils/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _context = require('../util/context');

var _context2 = _interopRequireDefault(_context);

var _events = require('../util/events');

var events = _interopRequireWildcard(_events);

var _deprecateComponent = require('../utils/deprecateComponent');

var _deprecateComponent2 = _interopRequireDefault(_deprecateComponent);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var bind = events.createEventBinding('scroll', 'resize');

// https://material.io/guidelines/components/progress-activity.html#progress-activity-behavior
var Loader = exports.Loader = function Loader(_ref) {
  var className = _ref.className;
  return _react2['default'].createElement(
    'div',
    { className: className },
    'Loading...'
  );
};

Loader.displayName = 'Loader';
Loader.propTypes = {
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string
};

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('InfiniteScroll', function (theme) {
  return {
    progress: {
      display: 'inline-block',
      paddingTop: theme.typography.rhythmByUnit(4),
      paddingBottom: theme.typography.rhythmByUnit(6),
      width: '100%',
      textAlign: 'center'
    }
  };
});

var InfiniteScroll = (_temp2 = _class = function (_PureComponent) {
  _inherits(InfiniteScroll, _PureComponent);

  function InfiniteScroll() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, InfiniteScroll);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = InfiniteScroll.__proto__ || Object.getPrototypeOf(InfiniteScroll)).call.apply(_ref2, [this].concat(args))), _this), _this.removeListener = function () {}, _this.addListener = function () {
      var scrollEl = _this.props.scrollEl;

      _this.removeListener();
      if (!scrollEl) return;
      _this.removeListener = bind(scrollEl, _this.scrollListener, {
        passive: true
      });
    }, _this.scrollListener = function () {
      var _this$props = _this.props,
          hasMore = _this$props.hasMore,
          loadMore = _this$props.loadMore,
          scrollEl = _this$props.scrollEl,
          threshold = _this$props.threshold,
          waitingForLoad = _this$props.waitingForLoad;

      // don't load more if there are no more items to load or we are
      // waiting

      if (!scrollEl || !hasMore || waitingForLoad) return;

      var offset = _this.getOffset();

      if (offset <= _this.getFullThreshold()) return;

      setTimeout(loadMore, 0);
      _this.removeListener();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InfiniteScroll, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        this.scrollListener();
        this.addListener();
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        this.removeListener();
      }

      return componentWillUnmount;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate(prevProps) {
        var prevScrollEl = prevProps.scrollEL;
        var scrollEl = this.props.scrollEl;

        // same element, so move on

        if (prevScrollEl === scrollEl) return;

        // new scroll element add, so initialize
        if (!prevScrollEl) {
          this.scrollListener();
        }

        this.addListener();
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'getOffset',
    value: function () {
      function getOffset() {
        var scrollEl = this.props.scrollEl;

        return scrollEl !== _context2['default'] ? scrollEl.scrollTop + scrollEl.clientHeight : _context2['default'].scrollY + _context2['default'].innerHeight;
      }

      return getOffset;
    }()
  }, {
    key: 'getFullThreshold',
    value: function () {
      function getFullThreshold() {
        var _props = this.props,
            scrollEl = _props.scrollEl,
            threshold = _props.threshold;

        return scrollEl !== _context2['default'] ? scrollEl.scrollHeight - threshold : this.container ? this.container.clientHeight - threshold : Infinity;
      }

      return getFullThreshold;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this2 = this;

        var _props2 = this.props,
            children = _props2.children,
            hasMore = _props2.hasMore,
            Loader = _props2.loader,
            loadMore = _props2.loadMore,
            scrollEl = _props2.scrollEl,
            threshold = _props2.threshold,
            waitingForLoad = _props2.waitingForLoad,
            other = _objectWithoutProperties(_props2, ['children', 'hasMore', 'loader', 'loadMore', 'scrollEl', 'threshold', 'waitingForLoad']);

        var classes = this.context.styleManager.render(styleSheet);

        return _react2['default'].createElement(
          'div',
          _extends({}, other, { ref: function () {
              function ref(c) {
                return _this2.container = c;
              }

              return ref;
            }() }),
          children,
          hasMore && _react2['default'].createElement(Loader, { className: classes.progress, ref: function () {
              function ref(c) {
                return _this2.loader = c;
              }

              return ref;
            }() })
        );
      }

      return render;
    }()
  }]);

  return InfiniteScroll;
}(_react.PureComponent), _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _class.propTypes = {
  /**
   * The content of the component.
   */
  children: _PropTypes2['default'].node,
  /**
   * boolean indicating whether or not there is more content to be loaded
   */
  hasMore: _PropTypes2['default'].bool,
  /**
   * function called when more data is needed
   */
  loadMore: _PropTypes2['default'].func.isRequired,
  /**
   * the DOM reference of the container that needs infinite scrolling, if window isn't scrolling
   */
  scrollEl: _PropTypes2['default'].object,
  /**
   * the distance from the bottom of the container (in px) at which to call `loadMore`
   */
  threshold: _PropTypes2['default'].number,
  /**
   * the component to use as the loading indicator at the bottom of the list
   */
  loader: _PropTypes2['default'].func,
  /**
   * boolean indicating whether or not `loadMore` should be called
   */
  waitingForLoad: _PropTypes2['default'].bool
}, _class.defaultProps = {
  hasMore: false,
  threshold: 250,
  loader: Loader,
  scrollEl: _context2['default']
}, _temp2);


InfiniteScroll.displayName = 'InfiniteScroll';

exports['default'] = (0, _deprecateComponent2['default'])(InfiniteScroll, 'InfiniteScroll is deprecated, use InfiniteList instead');


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/List/InfiniteScroll.js
// module id = 684
// module chunks = 32